import * as z from 'zod';

// Types
import { CTAZod } from '@/types/CTAType';
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const NumberedListZod = z.object({
  __component: z.literal('block.numbered-list'),
  id: z.number(),
  title: TitleZod,
  waveWrapper: WaveWrapperZod.nullable(),
  items: z.array(
    z.object({
      id: z.number(),
      title: TitleZod,
      paragraph: ParagraphZod,
    }),
  ),
  cta: CTAZod.nullable(),
  withDrawnLine: z.boolean(),
  paragraph: ParagraphZod.nullable(),
});

export { NumberedListZod };
export type NumberedListType = z.infer<typeof NumberedListZod>;
